import React, { Component, Fragment } from "react";

import Grafico4 from "../../Components/ProducaoEP/Realizado/Grafico4";
import NomeUnidade from "../../Components/UI/NomeUnidade";
import MenuRelatorioEP from "../../pages/ProducaoEP/menuRelatorioEP";
import TabelaMetaRealizado from "../../Components/ProducaoEP/Realizado/Relatorio3/TabelaMetaRealizado";
import NovoRelatorioMensal from "../../Components/ProducaoEP/Realizado/NovoRelatorioMensal";

export default class GraficosPage extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <Fragment>

                <NomeUnidade unidade={"Relatórios"} />

                <div className="content">
                    <MenuRelatorioEP />
                    <div className="row">
                        <div className="col-md-12">

                            <Grafico4 />
                            <NovoRelatorioMensal />
                            {/* <TabelaMetaRealizado isExibeFiltro={true} /> */}

                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}